import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGroupAdminGroup, IGroupAdminItem, IGroupsAdminList } from 'v3/data/store/groupAdmin/types';
import { groupsAdminInitialState } from './state';

export const groupsAdminSlice = createSlice({
  name: 'groupAdmin',
  initialState: groupsAdminInitialState,
  reducers: {
    setFilterRowsPerPage: (state, action: PayloadAction<number>) => {
      state.filter.rowsPerPage = action.payload;
      return state;
    },
    setFilterCurrentPage: (state, action: PayloadAction<number>) => {
      state.filter.page = action.payload;
      return state;
    },
    setGroupAdminList: (state, action: PayloadAction<IGroupsAdminList>) => {
      state.list = action.payload;
      return state;
    },
    setAllGroups: (state, action: PayloadAction<IGroupAdminGroup[]>) => {
      state.allGroups = action.payload;
      return state;
    },
    setGroupAdminSelected: (state, action: PayloadAction<IGroupAdminItem>) => {
      state.id = action.payload.id;
      state.storeUserId = action.payload.storeUserId;
      state.name = action.payload.name;
      state.email = action.payload.email;
      state.groups = action.payload.groupAdmin;
      return state;
    },
    setFilterGroupAdminName: (state, action: PayloadAction<string>) => {
      state.filter.name = action.payload;
      return state;
    },
    setFilterGroupAdminStoreGroupId: (state, action: PayloadAction<string[]>) => {
      state.filter.storeGroupIds = action.payload;
      return state;
    },
    clearFilterGroupAdmin: (state) => {
      state.filter = groupsAdminInitialState.filter;
      return state;
    },
  },
});
